import { AdConfigs } from "@/app/layout/useAdManager";

export const DETAILS_ADS: AdConfigs = {
  Horsezone_Details_Top: {
    unitId: "/23304440151/Horsezone_Details_Top",
    elementId: "div-gpt-ad-1748918900313-0",
    width: 728,
    height: 90,
    minWidth: 800,
  },
  Horsezone_Details_Side: {
    unitId: "/23304440151/Horsezone_Details_Side",
    elementId: "div-gpt-ad-1748918926661-0",
    width: 300,
    height: 250,
  },
  Horsezone_Details_Bottom: {
    unitId: "/23304440151/Horsezone_Details_Bottom",
    elementId: "div-gpt-ad-1748918956758-0",
    width: 728,
    height: 90,
    minWidth: 800,
  },
};
